module.exports = __webpack_public_path__ + "img/horses_hands.aed0c2e2.png";